import { Separator, Text } from "@fluentui/react";

export const SectionDivider = ({ text }: { text: string }) => (
  <Separator alignContent="start" styles={{ content: { paddingLeft: 0 } }}>
    <Text styles={{ root: { fontSize: "24px", fontWeight: 600 } }} variant="large">
      {text}
    </Text>
  </Separator>
);
